import { render, staticRenderFns } from "./store-type.vue?vue&type=template&id=38f03922&scoped=true"
import script from "./store-type.vue?vue&type=script&lang=js"
export * from "./store-type.vue?vue&type=script&lang=js"
import style0 from "./store-type.vue?vue&type=style&index=0&id=38f03922&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38f03922",
  null
  
)

export default component.exports